import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createReward } from '~/services/AgentHub/AgentService';

import { CreateRewardParams, Reward } from '~/types/services/agentHub';

import { rewardQueryKeys } from './useListRewards';

interface UseCreateRewardOptions {
  onSuccess?: (data: Reward) => void;
  onError?: (error: Error) => void;
}

export function useCreateReward(options: UseCreateRewardOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateRewardParams) => {
      return await createReward(params);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: rewardQueryKeys.all });
      options.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
